module.exports = __webpack_public_path__ + "img/imageCardOne.2fd4fdb0.png";